<template>
  <a-modal v-model="visible" :title="$t('选择菜单')" :width="1000" destroyOnClose>
    <div slot="footer">
      <a-button @click="visible = false">{{ $t('取消') }}</a-button>
      <a-button :loading="loading" type="primary" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <div>
      <span>{{ $t('系统菜单') }}</span>
      <a-tree :treeData="systemMenuTree" :replaceFields="{ title: 'name', key: 'id' }" checkable defaultExpandAll v-model="systemMenuIds"></a-tree>
    </div>
    <div v-if="form.appId != null">
      <span>{{ $t('应用菜单') }}</span>
      <a-tree :treeData="menuTree" :replaceFields="{ title: 'name', key: 'id' }" checkable defaultExpandAll v-model="menuIds"></a-tree>
    </div>
  </a-modal>
</template>
<script>
import { saveRoleMenus } from '@/api/system/role'
import { getMenuTree, getMenusByRoleId } from '@/api/system/menu'

export default {
  data() {
    return {
      visible: false,
      form: {},
      loading: false,
      systemMenuTree: [],
      systemMenuIds: [],
      menuIds: [],
      menuTree: [],
      allMenuIds: [],
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.user
    },
  },
  created() {
  },
  methods: {
    show(data) {
      this.form = { ...data }
      this.systemMenuTree = []
      this.systemMenuIds = []
      this.menuIds = []
      this.menuTree = []
      this.allMenuIds = []
      this.loadOptions()
      this.visible = true
    },
    loadOptions() {
      getMenuTree().then(res => {
        this.systemMenuTree = res.data || []
        this.resetMenuIds()
      })
      getMenuTree({ appId: this.form.appId }).then(res => {
        this.menuTree = res.data || []
      })
      getMenusByRoleId(this.form.id).then(res => {
        if (res.code === 0) {
          this.allMenuIds = res.data?.map(e => e.id) ?? []
          this.resetMenuIds()
        }
      })
    },
    resetMenuIds() {
      if (this.allMenuIds.length == 0) {
        return
      }
      const fetchIds = (list) => {
        if (!(list?.length)) {
          return []
        }
        let result = []
        list.forEach(l => {
          result.push(l.id)
          const sub = fetchIds(l.children)
          result = result.concat(sub)
        })
        return result
      }
      const systemIds = fetchIds(this.systemMenuTree)
      this.systemMenuIds = this.allMenuIds.filter(e => systemIds.indexOf(e) >= 0)
      this.menuIds = this.allMenuIds.filter(e => systemIds.indexOf(e) < 0)
    },
    handleCommit() {
      this.loading = true
      const all = this.systemMenuIds.concat(this.menuIds)
      const commitData = {
        id: this.form.id,
        menus: all.map(e => ({ id: e }))
      }
      saveRoleMenus(commitData).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t('保存成功'))
          this.$emit('ok', this.form)
          this.visible = false
        } else {
          this.$message.error(res.message || this.$t('保存失败'))
        }
      }).catch(err => {
        this.$message.error(this.$t('保存失败'))
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>